// extracted by mini-css-extract-plugin
module.exports =  {"menuBarCarbon":"menuBarCarbon_aXz8_0z3"};